import * as React from 'react';

import PageNavigation from 'components/common/PageNavigation';
import Routes from 'routing/Routes';
import { Row } from 'components/bootstrap';

const ArchivePageNavigation = () => {
  const NAV_ITEMS = [
    { description: 'Overview', path: Routes.pluginRoute('SYSTEM_ARCHIVES'), exactPathMatch: true },
    {
      description: 'Configuration',
      path: Routes.pluginRoute('SYSTEM_ARCHIVES_CONFIGURATION'),
      permissions: ['archiveconfig:read', 'archiveconfig:update'],
    },
    {
      description: 'Manage Backends',
      path: Routes.pluginRoute('SYSTEM_ARCHIVES_BACKENDS'),
      permissions: ['archiveconfig:read', 'archiveconfig:update'],
    },
  ];

  return (
    <Row>
      <PageNavigation items={NAV_ITEMS} />
    </Row>
  );
};

export default ArchivePageNavigation;
